'use client';
var classes = {"root":"m_d6493fad"};

export { classes as default };
//# sourceMappingURL=TypographyStylesProvider.module.css.mjs.map
